<template>
  <footer class="footer">
    <div class="footerWrap">
      <div class="toPageTop u-containar">
        <button class="toPageTop_btn" type="button" @click="toPageTop()">
          トップに戻る<i></i>
        </button>
      </div>

      <BreadCrumb
        v-if="$route.meta.breadCrumb && $route.meta.breadCrumb.length > 0"
      />

      <div class="innerLinks">
        <div class="u-containar">
          <ul>
            <li v-for="(item, i) in innerLinks" :key="i">
              <router-link :to="item.link">{{ item.label }}</router-link>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="$route.path === '/'" class="outerLinks u-containar">
        <div class="outerLinks_top">
          <template v-for="(item, i) in companyLinks01" :key="i">
            <a :href="item.link" target="_blank" rel="noopener noreferrer">
              {{ item.label }}
            </a>
          </template>
        </div>
        <div class="outerLinks_bottom">
          <template v-for="(item, i) in companyLinks02" :key="i">
            <a :href="item.link" target="_blank" rel="noopener noreferrer">
              {{ item.label }}
            </a>
          </template>
        </div>
      </div>

      <div class="copyright u-containar">
        <p>株式会社マイナビCopyright © Mynavi Corporation</p>
        <img
          :src="logoImgUrl"
          alt="プライバシー保護マーク"
          @error="onImgError"
        />
      </div>

      <MynaviLinks v-if="$route.path === '/'" />

      <div class="copyrightPC u-containar">
        <div class="copyrightPC_l">
          <ul>
            <li v-for="(item, i) in companyLinks01" :key="i">
              <a :href="item.link" target="_blank" rel="noopener noreferrer">
                {{ item.label }}
              </a>
            </li>
            <li v-for="(item, i) in companyLinks02" :key="i">
              <a :href="item.link" target="_blank" rel="noopener noreferrer">
                {{ item.label }}
              </a>
            </li>
          </ul>
          <p>Copyright © Mynavi Corporation</p>
        </div>
        <img
          :src="logoImgUrl"
          alt="プライバシー保護マーク"
          @error="onImgError"
        />
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { ref, defineComponent } from 'vue'
import MynaviLinks from '@/components/block/MynaviLinks.vue'
import BreadCrumb from '@/components/elements/BreadCrumb.vue'
import smoothscroll from 'smoothscroll-polyfill'

export default defineComponent({
  name: 'Footer',

  components: {
    MynaviLinks,
    BreadCrumb
  },

  setup() {
    smoothscroll.polyfill()

    const toPageTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }

    const innerLinks = [
      {
        link: '/guide',
        label: 'ご利用ガイド'
      },
      {
        link: '/news',
        label: 'お知らせ'
      },
      {
        link: '/faq',
        label: 'よくある質問'
      },
      {
        link: '/contact/input',
        label: 'お問い合わせ'
      },
      {
        link: '/sitemap',
        label: 'サイトマップ'
      },
      {
        link: '/terms',
        label: '利用規約・個人情報保護方針'
      },
      {
        link: '/privacy_policy',
        label: '個人情報の取扱について'
      }
    ]

    const companyLinks01 = [
      {
        link: 'https://www.mynavi.jp/company/',
        label: '会社概要'
      },
      {
        link: 'https://www.mynavi.jp/access/',
        label: 'アクセス'
      },
      {
        link: 'https://www.mynavi.jp/company/sustainability/',
        label: 'サスティナビリティ'
      }
    ]

    const companyLinks02 = [
      {
        link: 'https://www.mynavi.jp/recruit/',
        label: '採用'
      },
      {
        link: 'https://www.mynavi.jp/company/group/',
        label: 'グループ企業'
      },
      {
        link: 'https://www.mynavi.jp/privacy/',
        label: '個人情報保護方針'
      }
    ]

    const logoImgUrl = ref('https://conts1.mynv.jp/privacy.png')
    const onImgError = () => {
      logoImgUrl.value = 'https://conts2.mynv.jp/privacy.png'
    }
    return {
      toPageTop,
      innerLinks,
      companyLinks01,
      companyLinks02,
      logoImgUrl,
      onImgError
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.footer {
  margin-top: auto;
}

.footerWrap {
  padding-bottom: 66px;
  @include mixins.media() {
    padding-bottom: 0;
  }
}

.toPageTop {
  margin-bottom: 17px;
  margin-top: 32px;
}

.toPageTop_btn {
  display: flex;
  margin-left: auto;
  align-items: center;
  text-align: right;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1;
  color: var.$color-main-text;

  i {
    display: inline-block;
    position: relative;
    margin-left: 8px;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      content: '';
      width: 6px;
      height: 6px;
      border-top: 1px solid var.$color-main;
      border-left: 1px solid var.$color-main;
      transform: rotate(45deg) translate(12px, 1px);
    }

    &::after {
      display: inline-block;
      content: '';
      width: 21px;
      height: 21px;
      border: 1px solid var.$color-main;
      border-radius: 100%;
      transition: background-color 0.2s;
    }
  }

  &:hover {
    opacity: 1;

    i:after {
      background-color: #e5f7f6;
    }
  }
}

.breadCrumb {
  overflow: auto;
  white-space: nowrap;
  margin-top: 23px;
  padding-bottom: 8px;
  @include mixins.media(lg) {
    border-top: 1px solid var.$color-border-gray;
    padding-top: 9px;
    padding-bottom: 8px;
  }
  &_list {
    display: flex;
    font-size: 1.2rem;
    color: var.$color-hidden-text;
    li {
      &:not(:first-child) {
        &::before {
          content: '>';
          font-size: 1rem;
          margin-left: 1.4rem;
          margin-right: 1.4rem;
        }
      }
      &:last-child {
        padding-right: 16px;
      }
    }
  }
}

.innerLinks {
  background-color: var.$color-other-bg;
  ul {
    @include mixins.media(lg) {
      display: flex;
      justify-content: space-between;
    }
    li {
      &:not(:last-child) {
        border-bottom: 1px solid var.$color-border-gray;
        @include mixins.media(lg) {
          border: none;
        }
      }
      a {
        display: block;
        padding-top: 16px;
        padding-bottom: 16px;
        line-height: 1;
        position: relative;
        @include mixins.media(lg) {
          padding-top: 24px;
          padding-bottom: 24px;
        }
        &:after {
          content: '';
          display: inline-block;
          position: absolute;
          top: 50%;
          right: 2px;
          width: 6px;
          height: 6px;
          border-top: 1px solid var.$color-main;
          border-right: 1px solid var.$color-main;
          transform: translateY(-50%) rotate(45deg);
          @include mixins.media(lg) {
            position: static;
            margin-left: 14px;
          }
        }
      }
    }
  }
}

.outerLinks {
  margin-top: 22px;
  padding-bottom: 16px;
  line-height: 1;
  a {
    display: inline-block;
    + a {
      margin-left: 15px;
      border-left: 1px solid var.$color-black;
      padding-left: 15px;
    }
  }
  &_bottom {
    margin-top: 15px;
  }
  @include mixins.media(lg) {
    display: none;
  }
}

.copyright {
  margin-top: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  font-size: 1.2rem;
  color: #c6c6c6;
  line-height: 1;
  > img {
    height: 100%;
  }
  @include mixins.media(lg) {
    display: none;
  }
}

.copyrightPC {
  @include mixins.mediaMax(lg) {
    display: none;
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
  > img {
    width: 78px;
    margin-top: 16px;
    margin-bottom: 16px;
  }
  &_l {
    ul {
      display: flex;
      margin-bottom: 23.5px;
      font-size: 12px;
      line-height: 1;
      li + li::before {
        content: '｜';
      }
    }
    p {
      font-size: 12px;
      line-height: 1;
      color: #c6c6c6;
    }
  }
}

// .fixedNavGap {
//   // height: 55px;
//   height: calc(55px + env(safe-area-inset-bottom));
//   transition: height 0.2s ease;
// }
</style>
